var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GridPage',{attrs:{"form-default":{
                status: '',
            },"filters-default":{
                status: '',
                sort: '-posted_at',
            },"filter-items":[
                {
                    vModel: 'status',
                    title: '状態',
                    options: [
                        { text: '全て', value: '' },
                        { text: '下書き', value: 'draft' },
                        { text: '出品中', value: 'listed' },
                        { text: '取引中', value: 'sold' },
                        { text: '売却済', value: 'completed' } ],
                },
                {
                    vModel: 'sort',
                    title: '順番',
                    options: [
                        { text: '▼ 出品日時', value: '-posted_at' },
                        { text: '▼ いいね!の多い順', value: '-count_favorites' } ],
                } ],"filters-q-placeholder":"名前","form-modal-id":"item","search-action":"item/index"},scopedSlots:_vm._u([{key:"form",fn:function(ref){
            var form = ref.form;
            var init = ref.init;
return [_c('Item',{attrs:{"model":form,"init":init}})]}},{key:"column",fn:function(ref){
            var item = ref.item;
return [_c('b-col',[_c('div',{staticClass:"d-flex flex-wrap bd-highlight"},[_c('div',{staticClass:"p-2 flex-shrink-1 bd-highlight"},[_c('ItemThumb',{staticClass:"mb-1",attrs:{"model":item}})],1),_vm._v(" "),_c('div',{staticClass:"p-2 flex-grow-1 bd-highlight"},[_c('b-row',{staticClass:"no-gutters"},[_c('b-col',{staticClass:"align-self-center",attrs:{"md":"6"}},[_c('ItemBadges',{staticClass:"mb-1",attrs:{"model":item}}),_vm._v(" "),_c('p',{staticClass:"mb-1 font-weight-bold"},[_vm._v("\n                        "+_vm._s(item.name)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"mb-1"},[_vm._v("\n                        "+_vm._s(_vm._f("baseNumberFormatter")(item.price))+"\n                        "),(item.price2)?[_vm._v(" - "+_vm._s(_vm._f("baseNumberFormatter")(item.price2)))]:_vm._e()],2)],1),_vm._v(" "),_c('b-col',{staticClass:"align-self-center",attrs:{"md":"6"}},[_c('ItemInfo',{attrs:{"model":item}})],1)],1)],1)])])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }